/*
 * @Author: cc
 * @Date: 2020-12-29 16:40:40
 * @LastEditTime: 2020-12-30 17:02:47
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\shortVideo\left.js
 * @Description: 短视频类型稿件左侧模块
 */

angular.module('editshortVideoLeftModule', []).controller('EditShortVideoLeftCtrl', [
    '$scope',
    'trsHttpService',
    '$state',
    '$timeout',
    '$element',
    '$q',
    'noticeWindowService',
    function (
        $scope,
        trsHttpService,
        $state,
        $timeout,
        $element,
        $q,
        noticeWindowService,
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                platForm: 'waitcompiled',
                selectedChnlId: $state.params.account,
            };
            $scope.status = angular.extend($scope.status, $scope.trench);
        }

        /**
         * [initData description]初始化
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.data = {
                items: [],
                selected: {},
                AccountFirstFlag: {}, // 用于校验第一次进入
            };
        }

        /**
         * [requestData description]请求数据
         *
         * @return  {[type]}  [return description]
         */
        function requestData() {
            var deffer = $q.defer();
            if ($scope.data.items && $scope.data.items.length) {
                deffer.resolve();
                return deffer.promise;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.params, 'get').then(function (data) {
                $scope.data.items = !!data.DATA ? data.DATA : data;
                if (!$scope.data.items.length) {
                    return;
                }
                var account = $state.params.account;
                var items = $scope.data.items;
                if (account || $scope.data.selected[$scope.status.accountKey]) {
                    for (var i = 0; i < items.length; i++) {
                        if ($scope.data.selected[$scope.status.accountKey] === items[i][$scope.status.accountKey] || account === items[i][$scope.status.accountKey]) {
                            $scope.data.selected = items[i];
                            break;
                        }
                    }
                } else {
                    $scope.data.selected = data.DATA[0];
                }
                $scope.status.selectedChnlId = $scope.data.selected[$scope.status.accountKey];
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
        * [autoLocation description]自动定位
        * @param   {[type]}  platform  [platform description]
        * @return  {[type]}            [return description]
        */
        $scope.autoLocation = function (platform) {
            requestData().then(function () {
                $timeout(function () {
                    var routerArray = $state.current.name.split('.');
                    if (routerArray.length === 3 || routerArray.length === 4) {
                        if ($scope.status.selectedChnlId !== undefined) {
                            $scope.switchChannel(platform, $scope.data.selected);
                        } else {
                            $element.find('a')[0].click();
                        }
                    }
                });
            });
        };
        // 选择抖音渠道的栏目
        /**
         * [switchChannel description] 切换账号
         * @param   {[string]}  platform  [platform description]待编、待审、已签发
         * @param   {[object]}  channel   [channel description] 账号信息
         * @return  {[type]}              [return description]
         */
        $scope.switchChannel = function (platform, channel) {
            // 第一次进来的标志 调用有效期验证的弹窗提醒
            if (!$scope.data.AccountFirstFlag[channel[$scope.status.accountKey]]) {
                $scope.loadingPromise = noticeWindowService.getAccountValidityInfo($scope.status.mediaType, channel);
                $scope.data.AccountFirstFlag[channel[$scope.status.accountKey]] = true;
            }
            $scope.data.selected = channel;
            var routerName = 'front.editctr.' + $scope.status.router + '.' + platform;
            if (channel.IS_ORIGINAL === '1') {
                $state.go(routerName, { account: channel[$scope.status.accountKey], isOriginal: channel.IS_ORIGINAL, channelid: channel.CHANNELID }, { reload: false });
            } else {
                $state.go(routerName, { account: channel[$scope.status.accountKey], channelid: channel.CHANNELID }, { reload: false });
            }
            $scope.status.selectedChnlId = channel[$scope.status.accountKey];
            $scope.status.selectRecycle = false;
        };

        /**
         * [toRecycle description] 跳转到废稿箱
         * @return  {[type]}  [return description]
         */
        $scope.toRecycle = function () {
            if (!$scope.status.selectedChnlId) {
                return;
            }
            $scope.status.selectRecycle = true;
            var routerName = 'front.editctr.' + $scope.status.router + '.draftbox';
            $state.go(routerName, { account: $scope.status.selectedChnlId, channelid: $state.params.channelid }, { reload: routerName });
            $scope.status.selectedChnlId = '';
        };
    },
]);
